module.exports = __webpack_public_path__ + "static/media/transactions.b98aee40.jpg";